var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "form-group" }, [
    _vm.label ? _c("label", [_vm._v(_vm._s(_vm.label))]) : _vm._e(),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "list-group" },
      [
        _vm._l(_vm.files, function (file) {
          return [
            file.id
              ? _c(
                  "li",
                  { key: file.id, staticClass: "list-group-item" },
                  [
                    _vm.type == "images"
                      ? [
                          _c("img", {
                            staticClass: "img-thumbnail",
                            attrs: { src: file.url, alt: file.name },
                          }),
                        ]
                      : _vm.type == "videos"
                      ? [
                          _c(
                            "video",
                            {
                              attrs: {
                                controls: "",
                                width: "300",
                                height: "240",
                              },
                            },
                            [
                              _c("source", { attrs: { src: file.url } }),
                              _vm._v(
                                "\n                        Your browser does not support the video tag.\n                    "
                              ),
                            ]
                          ),
                        ]
                      : [
                          _c("div", { staticClass: "mr-auto" }, [
                            _c("h6", { staticClass: "font-weight-bold" }, [
                              _vm._v(
                                _vm._s(_vm.Lang.get("messages.file_name"))
                              ),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "crop-link" }, [
                              _vm._v(_vm._s(file.name)),
                            ]),
                          ]),
                        ],
                    _vm._v(" "),
                    _c("div", { staticClass: "ml-auto d-flex gap-2" }, [
                      _vm.view_type == "edit"
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-danger btn-sm",
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.openDeleteModal(file)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.Lang.get("messages.delete")) +
                                  "\n                    "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary btn-sm",
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.openFile(file.url)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.Lang.get("messages.download")) +
                              "\n                    "
                          ),
                        ]
                      ),
                    ]),
                  ],
                  2
                )
              : _vm._e(),
          ]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }